import React, {useEffect, useRef, useState} from 'react';

const FlixIntegration = ({ brand, barcode, prices, setHasFeed, hasFeed, data }) => {

  const scriptRef = useRef(null);
  const [scriptParams, setScriptParams] = useState()

  const {flix_id, flix_language, flix_active_brands} = data && data.configProvider || {}


  useEffect(() => {
    while (scriptRef.current.firstChild) {
      scriptRef.current.removeChild(scriptRef.current.firstChild);
    }


    if (scriptParams) {
      const scriptElement = document.createElement('script');
      scriptElement.setAttribute('type', 'text/javascript')
      scriptElement.setAttribute('async', true);
      scriptElement.setAttribute('src', 'https://media.flixfacts.com/js/loader.js');
      scriptElement.setAttribute('data-flix-autoload', 'minisite,inpage');
      scriptElement.setAttribute('data-flix-inpage', 'flix-inpage');
      scriptElement.setAttribute('data-flix-button', 'flix-minisite');
      scriptElement.setAttribute('data-flix-distributor', flix_id);
      scriptElement.setAttribute('data-flix-language', flix_language);

      Object.entries(scriptParams).forEach(([key, value]) => {
        scriptElement.setAttribute(key, value);
      })

      scriptRef.current.appendChild(scriptElement);
      setHasFeed(true)
      return () => {
        // scriptRef.current.removeChild(scriptElement);
      };
    }else {
      setHasFeed(false)
    }
  }, [scriptParams]);

  useEffect(() => {
    if (flix_active_brands && flix_active_brands.includes(brand)) {
      setScriptParams({
        'data-flix-brand': brand,
        'data-flix-ean': barcode,
        'data-flix-price': prices[0].amount,
      })
    }else{
      setScriptParams(null)
    }
  }, [brand, barcode, prices, flix_active_brands])

  return (
      <div id="syndication-tools-div" className="syndication-container">
        <div id="feed-content" ref={scriptRef}/>
      </div>

  )

};

export default FlixIntegration;
